import React from 'react';
import './Badge.css';

/**
 * Badge — compact status / label pill.
 *
 * Props:
 *   variant: 'neutral' | 'online' | 'offline' | 'pending' | 'warning'
 *          | 'success' | 'danger' | 'info' | 'brand'                (default 'neutral')
 *   size:    'sm' | 'md'                                             (default 'sm')
 *   dot:     boolean — show leading status dot
 *   subtle:  boolean — use soft-tinted background instead of bold
 */
export function Badge({
  variant = 'neutral',
  size = 'sm',
  dot = false,
  subtle = true,
  className = '',
  children,
  ...rest
}) {
  const classes = [
    'ui-badge',
    `ui-badge--${variant}`,
    `ui-badge--${size}`,
    subtle ? 'ui-badge--subtle' : 'ui-badge--bold',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes} {...rest}>
      {dot && <span className="ui-badge__dot" aria-hidden="true" />}
      <span className="ui-badge__label">{children}</span>
    </span>
  );
}

export default Badge;
